import { Box } from "@mui/material";
import ViewDrawer, { DetailItem } from "../../../../components/ViewDrawer";
import { useTranslation } from "../../../../i18n";
import { Vaccination } from "../../../../interfaces/Expenses/vaccination";
import styles from "../../../index.module.scss";

export interface vaccinationViewProps {
  open: boolean;
  onClose: Function;
  vaccination: Vaccination;
}

const VaccinationView = (props: vaccinationViewProps) => {
  const vaccination: Vaccination = props.vaccination;
  const { t } = useTranslation();
  let count = 1;

  return (
    <ViewDrawer open={props.open} onClose={props.onClose}>
      <Box className={styles.item_details}>
        <DetailItem
          index={count++}
          label={t("createdBy")}
          value={vaccination?.createdBy}
        />
        <DetailItem
          index={count++}
          label={t("createdAt")}
          value={vaccination?.createdAt.substring(0, 10)}
        />
        <DetailItem
          index={count++}
          label={t("updatedAt")}
          value={vaccination?.updatedAt.substring(0, 10)}
        />
      </Box>
    </ViewDrawer>
  );
};

export default VaccinationView;
